/**
 * Калькулятор вартості: тип сайту + дизайн + опції (мова, для магазину) → сума, долари, текст і посилання кнопки.
 * Кнопка «Замовити» відкриває попап із заявкою (CF7) і підставляє в нього вибір.
 * Розмітка й початковий стан — src/blocks/price-calculator/render.php; ціни лежать у data-атрибутах.
 * Дизайн з data-individual: суми немає — у кошторисі показується текст «Індивідуально».
 */
const fmt = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

function init(card) {
  const type = () => card.querySelector('input[name^="pc-type"]:checked');
  const design = () => card.querySelector('input[name^="pc-design"]:checked');
  const addon = (key) => card.querySelector(`.pc-switch input[data-addon="${key}"]`);
  const label = (key) => addon(key)?.closest('.pc-switch').querySelector('.pc-switch-text');
  const el = (sel) => card.querySelector(sel);
  const { rate, currency, usd, message, cta, individual, langBtn, langLabel, langPct, langMin } = card.dataset;
  const shop = el('.pc-shop');
  const shopOpts = () => [...card.querySelectorAll('input[data-shop-opt]')];

  // підсумок для попапа: оновлюється при кожному перерахунку
  const summary = { line: '', total: '' };
  let lastType = null;

  const update = () => {
    const t = type();
    const d = design();
    if (!t || !d) return;

    // інший тип сайту → блок «Для магазину» показуємо лише для магазину і скидаємо вибір
    if (t !== lastType) {
      lastType = t;
      shopOpts().forEach((o) => { o.checked = false; });
      if (shop) shop.hidden = t.dataset.shop !== '1';
      const pages = el('.pc-pages');
      if (pages) {
        pages.hidden = !t.dataset.pages;
        pages.querySelector('.pc-pages-text').textContent = t.dataset.pages || '';
      }
    }

    const isIndividual = d.dataset.individual === '1';
    // для «Figma + FSE» усе індивідуально: опції магазину ховаємо (текст «що входить» лишається) і скидаємо
    const shopFs = shop?.querySelector('.pc-col');
    if (shopFs) {
      shopFs.hidden = isIndividual;
      if (isIndividual) shopOpts().forEach((o) => { o.checked = false; });
    }
    const langOn = !!addon('lang')?.checked;
    const picked = t.dataset.shop === '1' ? shopOpts().filter((o) => o.checked) : [];
    const base = Number(d.value === 'custom' ? t.dataset.custom : t.dataset.fast);
    // мова: відсоток від базової суми (тип + дизайн), але не менше мінімуму
    const langFee = Math.max(Math.round((base * Number(langPct)) / 100), Number(langMin));
    const total = base + (langOn ? langFee : 0) + picked.reduce((s, o) => s + Number(o.dataset.price), 0);
    const money = isIndividual ? individual : `${fmt(total)} ${currency}`;

    el('.pc-total').textContent = money;
    const usdEl = el('.pc-usd-rate');
    const indNote = el('.pc-individual-note');
    if (indNote) indNote.hidden = !isIndividual;
    if (usdEl) {
      usdEl.hidden = isIndividual;
      usdEl.textContent = usd.replace('{usd}', `$${fmt(total / Number(rate))}`);
    }
    if (label('lang')) {
      label('lang').textContent = isIndividual
        ? langBtn.split('(')[0].trim()
        : langBtn.replace('{price}', `${fmt(langFee)} ${currency}`);
    }

    const ok = el('.pc-ok');
    ok.textContent = d.dataset.ok;
    ok.hidden = !d.dataset.ok;

    const optNames = picked.map((o) => o.dataset.name);
    summary.line = [t.dataset.name, d.dataset.name + (d.dataset.note && !isIndividual ? ` (${d.dataset.note})` : '')]
      .concat(langOn ? [langLabel] : [], optNames)
      .join(' · ');
    summary.total = money;

    const link = el('.pc-cta a');
    if (link && cta) {
      const text = message
        .replace('{type}', t.dataset.name)
        .replace('{design}', d.dataset.name)
        .replace('{stack}', '')
        .replace('{lang}', langOn ? `, ${langLabel}` : '')
        .replace('{options}', optNames.length ? `, опції: ${optNames.join(', ')}` : '')
        .replace('{total}', money);
      link.href = `${cta}${cta.includes('?') ? '&' : '?'}text=${encodeURIComponent(text)}`;
    }
  };

  card.addEventListener('change', update);
  update();
  const open = initModal(card, summary);
  // пункти без ціни: «Обговорити» відкриває ту саму заявку з позначкою пункту
  if (open) card.querySelectorAll('.pc-discuss').forEach((b) => b.addEventListener('click', (e) => open(e, b.dataset.name)));
}

/** Попап із заявкою. Стилі оболонки — .project-modal (global), форма — CF7 (див. PriceModal.php). */
function initModal(card, summary) {
  const modal = card.closest('.price-calc')?.querySelector('.pc-modal');
  const link = card.querySelector('.pc-cta a');
  if (!modal || !link) return null;

  // у <body>, щоб батьківські transform/overflow секції не ламали position: fixed
  document.body.append(modal);

  const formWrap = modal.querySelector('.project-modal__form');
  const success = modal.querySelector('.project-modal__success');
  const dialog = modal.querySelector('.project-modal__dialog');
  const contactMap = JSON.parse(modal.dataset.contactMap || '{}');
  let lastFocused = null;

  // підпис і плейсхолдер контактного поля — за обраним способом зв'язку
  const syncContact = () => {
    const method = modal.querySelector('input[name="contact-method"]:checked')?.value;
    const input = modal.querySelector('[name="your-contact"]');
    const lab = modal.querySelector('[data-pc-contact-label]');
    const [text, placeholder] = contactMap[method] || [];
    if (!input || !lab || !text) return;
    lab.textContent = `${text} `;
    const star = document.createElement('span');
    star.textContent = '*';
    lab.append(star);
    input.placeholder = placeholder;
    input.inputMode = method === 'Email' ? 'email' : method === 'Telegram' ? 'text' : 'tel';
  };

  const open = (e, topic = '') => {
    e.preventDefault();
    lastFocused = document.activeElement;
    const line = topic ? `${summary.line} · Цікавить: ${topic}` : summary.line;
    modal.querySelector('.pc-modal-summary-line').textContent = line;
    modal.querySelector('.pc-modal-summary-total').textContent = summary.total;
    const hidden = modal.querySelector('[name="calc-summary"]');
    if (hidden) hidden.value = `${line} — ${summary.total}`;
    formWrap.hidden = false;
    success.hidden = true;
    syncContact();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pm-lock');
    setTimeout(() => modal.querySelector('[name="your-name"]')?.focus(), 50);
  };

  const close = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pm-lock');
    lastFocused?.focus();
  };

  link.addEventListener('click', open);
  modal.addEventListener('click', (e) => {
    if (e.target.closest('[data-pc-close]')) close();
  });
  modal.addEventListener('change', (e) => {
    if (e.target.name === 'contact-method') syncContact();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
  // CF7: успішна відправка → екран подяки
  document.addEventListener('wpcf7mailsent', (e) => {
    if (!modal.contains(e.target)) return;
    formWrap.hidden = true;
    success.hidden = false;
    dialog.scrollTop = 0;
  });

  return open;
}

export default function priceCalculator() {
  document.querySelectorAll('.pc-card').forEach(init);
}
